import React from 'react';
import cx from 'classnames';
import './InfoForm.scss';

const InfoForm = (props) => {
  const { className, children } = props;

  return <div className={cx('info-form', className)}>{children}</div>;
};

export default InfoForm;
